import { useTranslation } from 'react-i18next';

import { MarketingCharacteristics } from '@app/constants';

import { ProductType } from '@mfe/shared/schema-types';
import { getCharacteristicValue } from '@mfe/shared/utils';

import ListItem from './easy-care-item';
import { getPriceAndDiscount } from '../../utils';

import styles from '../../styles/grouped-addon.module.scss';

const OffersList = ({ offers }: { offers: ProductType[] }) => {
  const { t } = useTranslation('ShopAddons');
  return (
    <div className={styles['offers-list']}>
      {offers.map((offer) => {
        const { id = '', name = '', description: defaultDesc = '', marketing_copy: { translations = [] } = {} } = offer;

        const characteristics = translations[0]?.characteristics ?? [];

        if (characteristics.length === 0) {
          return null;
        }

        const description =
          getCharacteristicValue(characteristics, MarketingCharacteristics.OFFER_DESCRIPTION) ?? defaultDesc;

        const tag = getCharacteristicValue(characteristics, MarketingCharacteristics.TAG);

        const { price, oldPrice = price, promotions, totalPromotionDuration } = getPriceAndDiscount(offer);

        const easyCareOffer = {
          id,
          name,
          oldPrice,
          price: t('priceAfterPromotion', { oldPrice, count: totalPromotionDuration }),
          description: description ?? '',
          promotions,
          duration: totalPromotionDuration,
          tag,
        };

        return <ListItem key={offer.id} product={easyCareOffer} />;
      })}
    </div>
  );
};

export default OffersList;
